module.exports = __webpack_public_path__ + "/assets/images/passenger-rights.9eea7f0.svg";